/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Ukrainian (Ukraine)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Введіть текст…',
  'fabric.editor.editorAssistiveLabel': 'Основна область вмісту: почніть вводити текст.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Відкрити довідку',
};
